import { IconLicense, IconDatabase, IconFlame } from '@tabler/icons';

export default [
  {
    icon: IconFlame,
    title: 'Automation',
    description:
      'Automate billing reminders, notifications and much more. ',
  },

  {
    icon: IconDatabase,
    title: 'Coordinated Management',
    description:
      'Communicate with care-takers and ancilliary service providers on-network.',
  },

  {
    icon: IconLicense,
    title: 'Flexible',
    description:
      'The entire infrastructure has been engineered with flexibility in mind. ',
  },
];